import { Card, Text, VStack } from '@chakra-ui/react'
import type { BusinessMetric } from '@/data/business-value'
import AnimatedCounter from './AnimatedCounter'

interface MetricCardProps {
  metric: BusinessMetric
  delay?: number
}

export default function MetricCard({ metric, delay = 0 }: MetricCardProps) {
  return (
    <Card.Root
      overflow="hidden"
      transition="all 0.3s"
      _hover={{ shadow: 'xl' }}
      h="100%"
      my={2}
      p={2}
    >
      <Card.Body p={6}>
        <VStack gap={2} align="center">
          <AnimatedCounter
            value={metric.value}
            prefix={metric.prefix}
            suffix={metric.suffix}
            delay={delay}
            className="text-3xl font-bold"
          />
          <Text fontWeight="bold" fontSize="sm" textAlign="center" color="brand.solid">
            {metric.label}
          </Text>
          <Text fontSize="xs" color="content.secondary" textAlign="center">
            {metric.description}
          </Text>
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
